import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import type { AnyRoute } from '@tanstack/react-router'
import { i18n } from '../../shared/i18n/i18n'
import sv from './locales/sv.json'
import en from './locales/en.json'

i18n.addResourceBundle('sv', 'calendar', sv, true, true)
i18n.addResourceBundle('en', 'calendar', en, true, true)

export function buildCalendarRoutes<TParent extends AnyRoute>(parent: TParent) {
  return [
    createRoute({
      getParentRoute: () => parent,
      path: '/calendar',
      component: lazyRouteComponent(
        () => import('./CalendarPage'),
        'CalendarPage',
      ),
    }),
  ]
}
